<template>
  <div class="input-error" v-if="showError">
    <transition name="fade" appear>
      <span class="input-error__message">
        {{errorMsg}}
      </span>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'input-error-common',
    props: {
      showError: Boolean,
      errorMsg: String
    }
  }
</script>

<style lang="scss">
  @import '~stylesheets/meta.scss';

  .input-error {
    margin: 4px 0;
    display: flex;
    justify-content: center;

    &__message {
      color: red;
      font-size: 12px;
    }
  }
</style>
